import { createSlice } from '@reduxjs/toolkit';

import { requestProductReviews } from 'src/redux/reviews/thunks';

// Announce basket changes off the real mutation thunks (add/update item) rather
// than submitOptionsForm — the latter is an async thunk that still dispatches
// pending/fulfilled even when it only opens the options drawer or fails
// validation, with no actual basket mutation. Action type strings are inlined
// to avoid a circular dependency with basket/thunks.
const BASKET_MUTATION_PENDING = [
  'basket/addItemToBasket/pending',
  'basket/updateItemInBasket/pending',
];
const BASKET_MUTATION_FULFILLED = [
  'basket/addItemToBasket/fulfilled',
  'basket/updateItemInBasket/fulfilled',
];
const BASKET_MUTATION_REJECTED = [
  'basket/addItemToBasket/rejected',
  'basket/updateItemInBasket/rejected',
];

export interface AccessibilityState {
  statusMessage: string;
}

export const initialState: AccessibilityState = {
  statusMessage: '',
};

export const { actions, reducer } = createSlice({
  name: 'accessibility',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(requestProductReviews.pending, (state, { meta }) => {
        if (!meta.arg.autoInitiated) {
          state.statusMessage = 'Loading reviews';
        }
      })
      .addCase(requestProductReviews.fulfilled, (state, { meta, payload }) => {
        if (!meta.arg.autoInitiated) {
          state.statusMessage = `Page ${payload.pagination.currentPage} of reviews loaded`;
        }
      })
      .addCase(requestProductReviews.rejected, (state, { meta }) => {
        if (!meta.arg.autoInitiated) {
          state.statusMessage = 'There was a problem loading reviews';
        }
      })
      .addMatcher(
        (action) => BASKET_MUTATION_PENDING.includes(action.type),
        (state) => {
          state.statusMessage = 'Updating basket';
        },
      )
      .addMatcher(
        (action) => BASKET_MUTATION_FULFILLED.includes(action.type),
        (state) => {
          state.statusMessage = 'Basket has been updated';
        },
      )
      .addMatcher(
        (action) => BASKET_MUTATION_REJECTED.includes(action.type),
        (state) => {
          state.statusMessage = 'There was a problem updating the basket';
        },
      );
  },
});
